module.exports = __webpack_public_path__ + "img/ybhl.1d94b112.png";